import { useQuery } from 'react-query'
import { getErrorString } from 'src/utils'
import { getChartOrganization, getChartOrganizations } from './api'
import { toast } from 'sonner'

// prettier-ignore
export const keys = {
    all: ['ALL'] as const,
    getChartOrganizations: () => [...keys.all, 'GET__CHART_ORGANIZATIONS'] as const,
    getChartOrganization: () => [...keys.all, 'GET__CHART_ORGANIZATION'] as const,

  }

export function useGetChartOrganizations(
  params: Parameters<typeof getChartOrganizations>[0],
) {
  return useQuery(
    keys.getChartOrganizations(),
    () => getChartOrganizations(params),
    {
      onError: (error) => {
        toast.error(getErrorString(error))
      },
    },
  )
}

export function useGetChartOrganization(
  params: Parameters<typeof getChartOrganization>[0],
) {
  return useQuery(
    keys.getChartOrganization(),
    () => getChartOrganization(params),
    {
      onError: (error) => {
        toast.error(getErrorString(error))
      },
    },
  )
}
